import { render, staticRenderFns } from "./concesion.vue?vue&type=template&id=27772b46&scoped=true"
import script from "./concesion.vue?vue&type=script&lang=js"
export * from "./concesion.vue?vue&type=script&lang=js"
import style0 from "./concesion.vue?vue&type=style&index=0&id=27772b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27772b46",
  null
  
)

export default component.exports